import React from 'react';
import PropTypes from 'prop-types';
import AnalyticsHandler from '../../../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../../../Utils/AnalyticsHandler/AnalyticsEventNames';
import { displayNotification } from '../../../../../Utils/GenericUtils';

function linkCell({ cell: { value: initialValue }, row: { original }, linkAccessor }) {
  const handleDownload = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(original[linkAccessor]);

      if (!response.ok) {
        const errorData = await response.json();
        displayNotification('error', 'Error', errorData.error || 'Failed to download invoice');
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = initialValue || 'invoice.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      displayNotification('error', 'Error', 'Failed to download invoice');
    }
  };

  return (
    <AnalyticsHandler eventName={AnalyticsEventNames.DOWNLOAD_INVOICE}>
      <a href={original[linkAccessor]} onClick={handleDownload}>
        {initialValue}
      </a>
    </AnalyticsHandler>
  );
}

linkCell.propTypes = {
  cell: PropTypes.object,
  row: PropTypes.object,
  linkAccessor: PropTypes.string,
};

export default linkCell;
